import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DgBs4TooltipDirective } from '../dg-bs4-tooltip.directive';



@NgModule({
  declarations: [
    DgBs4TooltipDirective
   ],
  imports: [
    CommonModule
  ],
  exports:[
    DgBs4TooltipDirective
  ]
})
export class Bs4TooltipsModule { }
